import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("@/layouts/AuthLayout.vue"),
    redirect: "/",
    meta: { requiresGuest: true },
    children: [
      {
        path: "/",
        name: "login",
        component: () => import("@/pages/LoginV2.vue"),
      },
    ],
  },
  {
    path: "/edi/login",
    name: "edi-vendor-login",
    component: () => import("@/pages/EDIVendorLogin.vue"),
    meta: { requiresGuest: false, skipAuth: true },
  },
  {
    path: "/edi/invoices",
    component: () => import("@/pages/edi/EDIInvoices.vue"),
    meta: { skipAuth: true },
    redirect: "/edi/invoices/listing",
    children: [
      {
        path: "listing",
        name: "edi-invoice-listing",
        component: () => import("@/pages/edi/EDIInvoiceListing.vue"),
        meta: { skipAuth: true },
      },
    ],
  },
  {
    path: "/store-selection",
    name: "store-selection",
    component: () => import("@/pages/StoreSelection.vue"),
    meta: {
      requiresAuth: true,
      title: "Store Selection",
    },
    beforeEnter: (to, from, next) => {
      if (
        store?.getters?.getSelectedStore &&
        Object.keys(store?.getters?.getSelectedStore).length
      ) {
        next("/home-layout");
      } else {
        next();
      }
    },
  },
  {
    path: "/home-layout",
    name: "home-layout",
    redirect: "/dashboard",
    component: () => import("@/layouts/HomeLayout.vue"),
    meta: {
      requiresAuth: true,
      checkSelectedStore: true,
    },
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("@/pages/Dashboard.vue"),
        meta: {
          title: "Dashboard",
          permission: "view-dashboard",
        },
      },
      {
        path: "/items",
        name: "items",
        // component: () => import("@/components/Inventory/ListingData.vue"),
        component: () => import("@/pages/InventoryV2.vue"),
        meta: {
          title: "Items",
          permission: "view-inventory",
        },
      },
      {
        path: "/item_linkage",
        name: "item_linkage",
        component: () => import("@/pages/ItemLinkage.vue"),
        meta: {
          title: "Item Linkage",
          permission: "view-group",
        },
      },
      {
        path: "/purchase-orders",
        name: "purchase_orders",
        component: () => import("@/pages/PurchaseOrders.vue"),
        meta: {
          title: "Purchase Orders",
          permission: "view-purchase-order",
        },
      },
      {
        path: "/purchase-orders/:purchase_order_id",
        name: "purchase_orders_detail",
        component: () => import("@/pages/PurchaseOrderDetail.vue"),
        meta: {
          title: "Purchase Order Detail",
          permission: "view-purchase-order",
        },
      },
      {
        path: "/new_items",
        name: "new_items",
        // component: () => import("@/components/NewItems/NewItemListing.vue"),
        component: () => import("@/pages/NewItemsV2.vue"),
        meta: {
          title: "New Items",
          permission: "view-new-items",
        },
      },
      {
        path: "/draft_items",
        name: "draft_items",
        component: () => import("@/pages/DraftItemsV2.vue"),
        meta: {
          title: "Draft Items",
          permission: "view-new-items",
        },
      },
      {
        path: "/item_expiration",
        name: "item_expiration",
        // component: () =>
        //   import("@/components/ItemExpiration/ItemExpirationListing.vue"),
        component: () => import("@/pages/ItemExpirationV2.vue"),
        meta: {
          title: "Item Expiration",
          permission: "view-item-expiration",
        },
      },
      {
        path: "/histories",
        name: "histories",
        // component: () => import("@/components/History/HistoryListing.vue"),
        component: () => import("@/pages/HistoryV2.vue"),
        meta: {
          title: "Histories",
          permission: "view-history",
        },
      },
      {
        path: "/vendors",
        name: "vendors",
        // component: () => import("@/components/Vendors/VendorListing.vue"),
        component: () => import("@/pages/VendorsV2.vue"),
        meta: {
          title: "Vendors",
          permission: "view-vendor",
        },
      },
      {
        path: "/invoices",
        name: "invoices",
        // component: () => import("@/components/Invoices/InvoiceListing.vue"),
        component: () => import("@/pages/InvoiceV2.vue"),
        meta: {
          title: "Invoices",
          permission: "view-invoice",
        },
      },
      {
        path: "/edi-invoices",
        name: "edi-invoices",
        component: () => import("@/pages/EDIInvoicesV2.vue"),
        meta: {
          title: "EDI Invoices",
          permission: "view-invoice",
        },
      },
      {
        path: "/invoice/:invoice_id",
        name: "invoice_detail_listing",
        // component: () =>
        //   import(
        //     "@/components/Invoices/InvoiceDetail/InvoiceDetailListing.vue"
        //   ),
        component: () => import("@/pages/InvoiceDetailV2.vue"),
        meta: {
          title: "Invoice Detail",
          permission: "view-invoice",
        },
      },
      {
        path: "/edi-invoice/:invoice_id",
        name: "edi-invoice_detail_listing",
        component: () => import("@/pages/EDIInvoiceDetailV2.vue"),
        meta: {
          title: "EDI Invoice Detail",
          permission: "edi-invoices",
        },
      },
      {
        path: "/draft_prices",
        name: "draft_prices",
        component: () => import("@/pages/DraftPricesV2.vue"),
        meta: {
          title: "Draft Prices",
          permission: "view-price-change",
        },
      },
      {
        path: "/price_change",
        name: "price_change",
        // component: () =>
        //   import("@/components/PriceChange/PriceChangeListing.vue"),
        component: () => import("@/pages/PriceChangeV2.vue"),
        meta: {
          title: "Price Change",
          permission: "view-price-change",
        },
      },
      {
        path: "/categories",
        name: "categories",
        // component: () => import("@/components/Category/CategoryListing.vue"),
        component: () => import("@/pages/CategoriesV2.vue"),
        meta: {
          title: "Categories",
          permission: "view-category",
        },
      },
      {
        path: "/departments",
        name: "departments",
        // component: () => import("@/components/Category/DepartmentListing.vue"),
        component: () => import("@/pages/DepartmentsV2.vue"),
        meta: {
          title: "Departments",
          permission: "view-department",
        },
      },
      {
        path: "/promotions",
        name: "promotions",
        component: () => import("@/pages/PromotionsV1.vue"),
        meta: {
          title: "Promotions",
          permission: "view-promotion",
        },
      },
      {
        path: "/stores",
        name: "stores",
        component: () => import("@/pages/Stores.vue"),
        meta: {
          title: "Stores",
          permission: "view-store",
        },
      },
      {
        path: "/razi-print/default-templates",
        name: "razi-print-default-templates",
        component: () => import("@/pages/RaziPrintDefaultTemplates.vue"),
        meta: {
          title: "Razi Print Default Templates",
          permission: "print-gateway",
        },
      },
      {
        path: "/razi-print/custom-templates",
        name: "razi-print-custom-templates",
        component: () => import("@/pages/RaziPrintCustomTemplates.vue"),
        meta: {
          title: "Razi Print Custom Templates",
          permission: "print-gateway",
        },
      },
      {
        path: "/razi-print/settings",
        name: "razi-print-settings",
        component: () => import("@/pages/RaziPrintSettings.vue"),
        meta: {
          title: "Razi Print Settings",
          permission: "print-gateway",
        },
      },
      {
        path: "/aisles",
        name: "aisles",
        component: () => import("@/pages/Aisles.vue"),
        meta: {
          title: "Aisles",
          permission: "view-aisle",
        },
      },
      {
        path: "/users",
        name: "users",
        // component: () => import("@/components/Users/UserListing.vue"),
        component: () => import("@/pages/UserV2.vue"),
        meta: {
          title: "Users",
          permission: "manage-users",
        },
      },
      {
        path: "/roles",
        name: "roles",
        // component: () => import("@/components/Roles/RoleListing.vue"),
        component: () => import("@/pages/RoleV2.vue"),
        meta: {
          title: "Roles",
          permission: "manage-roles",
        },
      },
      // {
      //   path: "/bartender",
      //   name: "bartender",
      //   component: () => import("@/pages/BarTender.vue"),
      //   meta: {
      //     title: "BarTender",
      //     permission: "manage-bartender",
      //   },
      // },
      {
        path: "/batches",
        name: "batches",
        // component: () => import("@/components/batches/batchListing.vue"),
        component: () => import("@/pages/BatchV2"),
        meta: {
          title: "Batches",
          permission: "view-batch",
        },
      },
      {
        path: "/batches-detail/:batch_id",
        name: "batches-detail",
        component: () => import("@/pages/BatchDetail.vue"),
        meta: {
          title: "Batches Detail",
          permission: "view-batch",
        },
      },
      {
        path: "/workstation",
        name: "workstation",
        component: () => import("@/pages/WorkStation.vue"),
        meta: {
          title: "WorkStation",
          permission: "view-workstation",
        },
      },
      {
        path: "/tasks",
        name: "tasks",
        component: () => import("@/pages/Tasks.vue"),
        meta: {
          title: "Tasks",
          permission: "view-task",
        },
      },
      {
        path: "/task-categories",
        name: "task-categories",
        component: () => import("@/pages/TeamCategories.vue"),
        meta: {
          title: "Task Categories",
          permission: "view-task",
        },
      },
    ],
  },
  // ========================================
  // NO-SIDEBAR LAYOUT ROUTES
  // ========================================
  // This route structure provides pages without the sidebar navigation
  // Used specifically for WorkStation iframes to create a clean, focused interface
  // All child routes are relative paths that will be nested under /no-sidebar
  // Example: /no-sidebar/dashboard, /no-sidebar/items, etc.
  {
    path: "/no-sidebar",
    name: "no-sidebar-layout",
    component: () => import("@/layouts/NoSidebarLayout.vue"),
    meta: {
      requiresAuth: true, // User must be authenticated
      checkSelectedStore: true, // User must have a selected store
    },
    children: [
      // Dashboard page without sidebar
      {
        path: "dashboard",
        name: "dashboard-no-sidebar",
        component: () => import("@/pages/Dashboard.vue"),
        meta: {
          title: "Dashboard",
          permission: "view-dashboard",
        },
      },
      // Inventory Management Pages
      {
        path: "items",
        name: "items-no-sidebar",
        component: () => import("@/pages/InventoryV2.vue"),
        meta: {
          title: "Items",
          permission: "view-inventory",
        },
      },
      {
        path: "item_linkage",
        name: "item_linkage-no-sidebar",
        component: () => import("@/pages/ItemLinkage.vue"),
        meta: {
          title: "Item Linkage",
          permission: "view-group",
        },
      },
      {
        path: "new_items",
        name: "new_items-no-sidebar",
        component: () => import("@/pages/NewItemsV2.vue"),
        meta: {
          title: "New Items",
          permission: "view-new-items",
        },
      },
      {
        path: "draft_items",
        name: "draft_items-no-sidebar",
        component: () => import("@/pages/DraftItemsV2.vue"),
        meta: {
          title: "Draft Items",
          permission: "view-new-items",
        },
      },
      {
        path: "item_expiration",
        name: "item_expiration-no-sidebar",
        component: () => import("@/pages/ItemExpirationV2.vue"),
        meta: {
          title: "Item Expiration",
          permission: "view-item-expiration",
        },
      },
      {
        path: "histories",
        name: "histories-no-sidebar",
        component: () => import("@/pages/HistoryV2.vue"),
        meta: {
          title: "Trackability",
          permission: "view-history",
        },
      },
      {
        path: "price_change",
        name: "price_change-no-sidebar",
        component: () => import("@/pages/PriceChangeV2.vue"),
        meta: {
          title: "Price Change",
          permission: "view-price-change",
        },
      },
      {
        path: "draft_prices",
        name: "draft_prices-no-sidebar",
        component: () => import("@/pages/DraftPricesV2.vue"),
        meta: {
          title: "Draft Prices",
          permission: "view-price-change",
        },
      },

      // Organization Management Pages
      {
        path: "departments",
        name: "departments-no-sidebar",
        component: () => import("@/pages/DepartmentsV2.vue"),
        meta: {
          title: "Departments",
          permission: "view-department",
        },
      },
      {
        path: "categories",
        name: "categories-no-sidebar",
        component: () => import("@/pages/CategoriesV2.vue"),
        meta: {
          title: "Categories",
          permission: "view-category",
        },
      },
      {
        path: "aisles",
        name: "aisles-no-sidebar",
        component: () => import("@/pages/Aisles.vue"),
        meta: {
          title: "Aisles",
          permission: "view-aisle",
        },
      },
      {
        path: "batches",
        name: "batches-no-sidebar",
        component: () => import("@/pages/BatchV2"),
        meta: {
          title: "Batches",
          permission: "view-batch",
        },
      },
      {
        path: "promotions",
        name: "promotions-no-sidebar",
        component: () => import("@/pages/PromotionsV1.vue"),
        meta: {
          title: "Promotions",
          permission: "view-promotion",
        },
      },

      // Vendor & Invoice Management Pages
      {
        path: "vendors",
        name: "vendors-no-sidebar",
        component: () => import("@/pages/VendorsV2.vue"),
        meta: {
          title: "Vendors",
          permission: "view-vendor",
        },
      },
      {
        path: "invoices",
        name: "invoices-no-sidebar",
        component: () => import("@/pages/InvoiceV2.vue"),
        meta: {
          title: "Invoices",
          permission: "view-invoice",
        },
      },
      {
        path: "edi-invoices",
        name: "edi-invoices-no-sidebar",
        component: () => import("@/pages/EDIInvoicesV2.vue"),
        meta: {
          title: "EDI Invoices",
          permission: "view-invoice",
        },
      },
      {
        path: "edi-invoice/:invoice_id",
        name: "edi-invoice_detail_listing-no-sidebar",
        component: () => import("@/pages/EDIInvoiceDetailV2.vue"),
        meta: {
          title: "EDI Invoice Detail",
          permission: "view-invoice",
        },
      },
      {
        path: "purchase-orders",
        name: "purchase_orders-no-sidebar",
        component: () => import("@/pages/PurchaseOrders.vue"),
        meta: {
          title: "Purchase Orders",
          permission: "view-purchase-order",
        },
      },

      // System Management Pages
      {
        path: "stores",
        name: "stores-no-sidebar",
        component: () => import("@/pages/Stores.vue"),
        meta: {
          title: "Stores",
          permission: "view-store",
        },
      },
      {
        path: "razi-print/default-templates",
        name: "razi-print-default-templates-no-sidebar",
        component: () => import("@/pages/RaziPrintDefaultTemplates.vue"),
        meta: {
          title: "Razi Print Default Templates",
          permission: "print-gateway",
        },
      },
      {
        path: "razi-print/custom-templates",
        name: "razi-print-custom-templates-no-sidebar",
        component: () => import("@/pages/RaziPrintCustomTemplates.vue"),
        meta: {
          title: "Razi Print Custom Templates",
          permission: "print-gateway",
        },
      },
      {
        path: "razi-print/settings",
        name: "razi-print-settings-no-sidebar",
        component: () => import("@/pages/RaziPrintSettings.vue"),
        meta: {
          title: "Razi Print Settings",
          permission: "print-gateway",
        },
      },
      {
        path: "users",
        name: "users-no-sidebar",
        component: () => import("@/pages/UserV2.vue"),
        meta: {
          title: "Users",
          permission: "manage-users",
        },
      },
      {
        path: "roles",
        name: "roles-no-sidebar",
        component: () => import("@/pages/RoleV2.vue"),
        meta: {
          title: "Roles",
          permission: "manage-roles",
        },
      },
      // {
      //   path: "bartender",
      //   name: "bartender-no-sidebar",
      //   component: () => import("@/pages/BarTender.vue"),
      //   meta: {
      //     title: "BarTender",
      //     permission: "manage-bartender",
      //   },
      // },
      {
        path: "tasks",
        name: "tasks-no-sidebar",
        component: () => import("@/pages/Tasks.vue"),
        meta: {
          title: "Tasks",
          permission: "view-task",
        },
      },
      {
        path: "task-categories",
        name: "task-categories-no-sidebar",
        component: () => import("@/pages/TeamCategories.vue"),
        meta: {
          title: "Task Categories",
          permission: "view-task",
        },
      },
    ],
  },
  {
    path: "*",
    name: "PageNotFound",
    component: () => import("@/pages/PageNotFound.vue"),
  },
];

export function getFirstAccessibleRoute(userPermissions = [], userRole = "") {
  const permissions = Array.isArray(userPermissions) ? userPermissions : [];
  const homeLayoutRoute = routes.find((route) => route.name === "home-layout");

  if (!homeLayoutRoute || !Array.isArray(homeLayoutRoute.children)) {
    return null;
  }

  const isAdmin = userRole === "Admin";

  const accessibleChild = homeLayoutRoute.children.find((childRoute) => {
    if (!childRoute || childRoute.redirect) {
      return false;
    }

    const routePath = childRoute.path || "";
    if (routePath.includes(":")) {
      return false;
    }

    const requiredPermission = childRoute.meta?.permission;

    if (!requiredPermission) {
      return true;
    }

    return isAdmin || permissions.includes(requiredPermission);
  });

  if (!accessibleChild) {
    return null;
  }

  return { name: accessibleChild.name };
}

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.getFirstAccessibleRoute = getFirstAccessibleRoute;

function checkPermission(
  requiredPermission,
  userPermissions,
  userRole,
  userData = null
) {
  if (userRole === "Admin") {
    return true;
  }
  if (userPermissions.includes(requiredPermission)) {
    return true;
  }

  // Special case: Allow employees to view tasks even without view-task permission
  if (requiredPermission === "view-task") {
    const isEmployee =
      userData?.is_employee === 1 || userData?.is_employee === true;
    if (isEmployee) {
      return true;
    }
  }

  return false;
}

router.beforeEach((to, from, next) => {
  // Global unsaved-changes guard (shows ConfirmationDialog via App.vue)
  // If user tries to navigate away while there are unsaved changes,
  // block navigation and open the confirmation dialog.
  if (
    to.fullPath !== from.fullPath &&
    store?.getters?.getHasUnsavedChanges &&
    store.getters.getHasUnsavedChanges === true &&
    !store.getters.getUnsavedChangesDialog?.open
  ) {
    store.commit("openUnsavedChangesDialog", {
      name: to.name,
      params: to.params,
      query: to.query,
    });
    return next(false);
  }

  // Redirect authenticated EDI vendors away from login page
  if (to.name === "edi-vendor-login") {
    const ediVendorSession = localStorage.getItem("edi_vendor_session");
    if (ediVendorSession) {
      return next({ name: "edi-invoice-listing" });
    }
  }

  // Skip authentication checks for EDI vendor routes
  if (to.matched.some((record) => record?.meta?.skipAuth)) {
    return next();
  }

  // Check if user is logged in
  const isLoggedIn = !!localStorage.getItem("token");

  // Redirect logged-in users away from auth pages
  if (to.matched.some((record) => record?.meta?.requiresGuest)) {
    if (isLoggedIn) {
      return next({ name: "dashboard" });
    }
  }

  if (to.matched.some((route) => route?.meta?.checkSelectedStore)) {
    if (
      !store?.getters?.getSelectedStore ||
      !Object.keys(store?.getters?.getSelectedStore).length
    ) {
      return next({ name: "store-selection" });
    }
  }
  // Check authentication for protected routes
  if (to.matched.some((route) => route?.meta?.requiresAuth)) {
    if (!isLoggedIn) {
      return next({ name: "login" });
    }
  }
  // Check for permission requirements
  const requiresPermission = to.matched.some(
    (record) => record.meta.permission
  );

  const hasUserData = !!localStorage.getItem("grocer_user");

  if (requiresPermission && hasUserData) {
    // Get user data from localStorage
    const userData = JSON.parse(localStorage.getItem("grocer_user"));
    const userPermissions = userData.permission_names || [];
    const userRole = userData.role_name;

    // Check if user has required permission
    const requiredPermission = to.meta.permission;
    const hasPermission = checkPermission(
      requiredPermission,
      userPermissions,
      userRole,
      userData
    );

    if (!hasPermission) {
      next({ name: "PageNotFound" });
      return;
    }
  }

  next();
});

export default router;
